/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Role_NewcomerInputs */



/**
* | output |
* | --- |
* | "Newcomer" |
*
* @param {Products_Leveling_Role_NewcomerInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_role_newcomer = /** @type {((inputs?: Products_Leveling_Role_NewcomerInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Role_NewcomerInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новичок")
	return /** @type {LocalizedString} */ ("Newcomer")
});